import { getType } from 'typesafe-actions'

import { withLoadingReducer } from '../loading'

import { SearchActions } from './actions'
import { SearchState } from './types'

export const initialState: SearchState = {
  companies: [],
  pageSize: 0,
  pageCount: 0,
  totalCount: 0
}

export const reducer = (state: SearchState = initialState, action: SearchActions): SearchState => {
  switch (action.type) {
    case getType(SearchActions.setLoadedCompanies): {
      const { payload } = action
      return {
        ...state,
        companies: payload.companies,
        pageSize: payload.pageSize,
        totalCount: payload.totalCount,
        pageCount: payload.pageCount
      }
    }
    default:
      return state
  }
}

export const searchReducer = withLoadingReducer(reducer, 'search', initialState)
